/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowPicnicTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowPicnic,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Picnic!",
    "Outdoor Feast Awaits!",
    "Fun Under the Sun!",
  ],
  title: "Picnic in the Park",
  description: "Organize a delightful picnic outing.",
  longDescription:
    "Gather your friends for a sunny picnic. Choose a date, pick a location, and decide on food and drinks to enjoy!",
  emoji: "🥗",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Picnic in the Park",
          emoji: "🥗",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the picnic?",
          emoji: "📅",
          completeAction: {
            question: "Decide on a location?",
            description: "Where should we set up our picnic?",
            addModules: [
              {
                type: ModuleType.Location,
                doneType: ModuleDoneType.Voting,
                title: "Where should we picnic?",
                emoji: "🏞",
                completeAction: {
                  question: "Decide on food and drinks?",
                  description: "What should we bring to eat and drink?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What food should we bring?",
                      emoji: "🥪",
                    },
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What drinks should we have?",
                      emoji: "🥤",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Enjoy the Outdoors!",
    outroDescription: "Your picnic plans are set! Enjoy your time in the sun!",
  },
};
